/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Dropdown,
  Select,
  notification,
  Menu, Drawer, Alert,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCaretDown, faPenToSquare,
} from '@fortawesome/free-solid-svg-icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import InvoiceActions from '@Actions/invoiceActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import SOActions from '@Actions/sales/soActions';
import ConvertToMo from '@Components/Sales/SalesOrder/ViewSalesOrder/ConvertToMo';
import Helpers from '@Apis/helpers';
import './style.scss';
import documentUINamesConstant from '../../../../../apis/documentUINamesConstant';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;
/**
 *
 */
function BulkSOActions({
  user, salesOrders, downloadInvoiceLoading, updateSOStatus,
  selectedRows, selectedRowKeys, callback, updateSOStatusLoading, selectedTenant,
}) {
  const [openBulkUpdate, setOpenBulkUpdate] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isStatusSelectEnabled, setIsStatusSelectEnabled] = useState(true);
  const [showConvertToMo, setShowConvertToMo] = useState(false);
  useEffect(() => {
    const customStatusSet = {};
    for (let i = 0; i < selectedRows?.length; i++) {
      customStatusSet[selectedRows?.[i]?.custom_status_info?.custom_status_id] = {
        name: selectedRows?.[i]?.custom_status_info?.status_name,
        type: selectedRows?.[i]?.custom_status_info?.type,
        custom_status_id: selectedRows?.[i]?.custom_status_info?.custom_status_id,
      };
    }
    if (Object.keys(customStatusSet)?.length > 1) {
      setIsStatusSelectEnabled(false);
      setSelectedStatus(customStatusSet[Object.keys(customStatusSet)?.[0]]);
    } else {
      setIsStatusSelectEnabled(true);
      setSelectedStatus(customStatusSet[Object.keys(customStatusSet)?.[0]]);
    }
  }, [selectedRowKeys]);

  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: item?.order_id }));
    }
    return [];
  };
  const firstObject = getDataSource(salesOrders?.data?.sales_orders)?.[0];

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  return (
    <Fragment>
      <div>
        <Dropdown
          overlay={(
            <Menu>
              <Menu.Item>
                <div onClick={() => {
                  if (downloadInvoiceLoading || !selectedRowKeys?.length) {
                    notification.open({
                      placement: 'top',
                      duration: 4,
                      type: 'warning',
                      // message: 'Please select one or more Sales Orders to Update Status',
                      message: `Please select one or more ${documentUINames.salesOrderUIName}s to Update Status`,
                    });
                  } else {
                    setOpenBulkUpdate(!openBulkUpdate);
                  }
                }}
                >
                  <FontAwesomeIcon icon={faPenToSquare} />
                  &nbsp; Bulk Update
                </div>
              </Menu.Item>
              {user?.tenant_info?.production_config?.sub_modules?.manufacturing_order?.is_active && Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.CREATE, user) && (
                <Menu.Item>
                  <div onClick={() => {
                    if (!selectedRowKeys?.length) {
                      notification.open({
                        placement: 'top',
                        duration: 4,
                        type: 'warning',
                        // message: 'Please select one or more Sales Orders to Update Status',
                        message: `Please select one or more ${documentUINames.salesOrderUIName}s to Update Status`,
                      });
                    } else if (selectedRows?.find((item) => item?.mrp_id)) {
                      notification.open({
                        placement: 'top',
                        duration: 4,
                        type: 'warning',
                        // message: 'The selected Sales Orders are linked with MRP so you cannot create Manufacturing Orders for them.',
                        message: `The selected ${documentUINames.salesOrderUIName}s are linked with MRP so you cannot create Manufacturing Orders for them.`,
                      });
                    } else {
                      setShowConvertToMo(!showConvertToMo);
                    }
                  }}
                  >
                    {/* <FontAwesomeIcon icon={faPenToSquare} /> */}
                    {/* &nbsp; */}
                    Send for Production
                  </div>
                </Menu.Item>
              )}
            </Menu>
          )}
          placement="topLeft"
          trigger={['click']}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          <div className="ba-button">
            Actions
            &nbsp;
            <FontAwesomeIcon icon={faCaretDown} />
          </div>
        </Dropdown>
      </div>
      <Drawer
        open={openBulkUpdate}
        onClose={() => setOpenBulkUpdate(!openBulkUpdate)}
        width="380px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '330px' }}>
            <H3Text text={`Bulk Update ${documentUINames.salesOrderUIName}s`} className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenBulkUpdate(false)} />
          </div>
        </div>

        <div className="ba-wrapper">
          <div className="ba-input__wrapper">
            <H3Text text="Select Status" className="ba-input__label" />
            {getDataSource(salesOrders?.data?.sales_orders)?.length > 0 && (
              <PRZSelect
                value={selectedStatus?.custom_status_id}
                className="filters__buttons-dropdown"
                onChange={(value) => {
                  const possibleStatuses = [firstObject?.custom_status_info, ...firstObject?.possible_status]?.find((possibleStatus) => possibleStatus?.custom_status_id === value);
                  setSelectedStatus({
                    name: possibleStatuses?.status_name,
                    type: possibleStatuses?.type,
                    custom_status_id: possibleStatuses?.custom_status_id,
                  });
                }}
                disabled={!isStatusSelectEnabled || ['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name)}
                placeholder="Select status.."
                filterOption={false}
              >
                {[firstObject?.custom_status_info, ...firstObject?.possible_status]
                  ?.filter((item) => (!['VOID', 'SENT_FOR_APPROVAL'].includes(selectedStatus?.type) ? !['VOID', 'SENT_FOR_APPROVAL'].includes(item?.type) : true))
                  ?.map((item) => (
                    <Option key={item?.custom_status_id} value={item?.custom_status_id}>
                      <div className="custom-status-form__color">
                        <div
                          className="custom-status-form__color-dot"
                          style={{ backgroundColor: item?.color_code }}
                        />
                        <span>{item?.status_name?.replaceAll('_', ' ')}</span>
                      </div>
                    </Option>
                  ))}
              </PRZSelect>
            )}
          </div>
          {!isStatusSelectEnabled && !['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name) && (
            <Alert
              showIcon
              type="warning"
              message={`Status of the ${documentUINames.salesOrderUIName}s will not be updated`}
              description={`You have selected ${documentUINames.salesOrderUIName.toLowerCase()}s with multiple statuses. Please add status filter or select ${documentUINames.salesOrderUIName.toLowerCase()}s on single status only.`}
            />
          )}
          {['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name) && isStatusSelectEnabled && (
            <Alert
              showIcon
              type="warning"
              message="Bulk status update not allowed"
              description={`You cannot update the status of ${documentUINames.salesOrderUIName.toLowerCase()}s in Draft or Cancelled status.`}
            />
          )}
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text="Confirm"
              onClick={() => {
                if (isStatusSelectEnabled && !['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedStatus?.name)) {
                  const payload = selectedRowKeys?.map((orderId) => ({
                    order_id: orderId,
                    status: selectedStatus?.type,
                    secondary_status: selectedStatus?.name,
                    custom_status_id: selectedStatus?.custom_status_id,
                  }));
                  updateSOStatus(payload, () => {
                    setOpenBulkUpdate(false);
                    callback();
                  });
                }
              }}
              isLoading={updateSOStatusLoading}
              disabled={updateSOStatusLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Drawer>
      <Drawer
        onClose={() => setShowConvertToMo(false)}
        open={showConvertToMo}
        width="975px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '925px' }}>
            <H3Text text="Create Manufacturing Orders" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowConvertToMo(false)} />
          </div>
        </div>
        <ConvertToMo
          selectedRows={selectedRows}
          inputTenant={selectedTenant?.[0]}
          callback={() => {
            setShowConvertToMo(false);
          }}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, CustomStatusReducers, SOReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  salesOrders: SOReducers.salesOrders,
  customStatusSalesOrder: CustomStatusReducers.customStatusSalesOrder,
  updateSOStatusLoading: SOReducers.updateSOStatusLoading,

});

const mapDispatchToProps = (dispatch) => ({
  updateInvoiceStatus: (payload, callback) => dispatch(InvoiceActions.updateInvoiceStatus(payload, callback)),
  updateSOStatus: (payload, callback) => dispatch(SOActions.updateSOStatus(payload, callback)),
});

BulkSOActions.propTypes = {
  salesOrders: PropTypes.any,
  user: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkSOActions));
